import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { getEstabelecimentoAtualId } from '../lib/estabelecimento';

// Campos personalizados do cadastro definidos pela prefeitura (item 2.27 — LGPD art. 5).
export type TipoCampoCadastro = 'texto' | 'data' | 'numero';
export interface CampoCadastro {
  id: string;
  nome: string;
  tipo: TipoCampoCadastro;
  obrigatorio: boolean;
}

/** Tipo de input HTML para cada tipo de campo. */
export function inputTypeDoCampo(tipo: TipoCampoCadastro): 'text' | 'date' | 'number' {
  return tipo === 'data' ? 'date' : tipo === 'numero' ? 'number' : 'text';
}

/** Carrega a lista de campos personalizados configurada pela prefeitura. */
export function useCamposCadastro(): CampoCadastro[] {
  const [campos, setCampos] = useState<CampoCadastro[]>([]);

  useEffect(() => {
    supabase.from('estabelecimentos').select('configuracoes').eq('id', getEstabelecimentoAtualId()).maybeSingle()
      .then(({ data }) => {
        const lista = (data?.configuracoes as { campos_customizados_cadastro?: CampoCadastro[] } | undefined)?.campos_customizados_cadastro;
        if (Array.isArray(lista)) setCampos(lista);
      });
  }, []);

  return campos;
}
